export const GALLERY_TARGET_ID = '#portal-accommodation-gallery';
